import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { ColorFresnelModel } from 'src/app/edit/models/color-fresnel.model';

@Component({
  selector: 'app-paint-palette-swatch',
  templateUrl: './paint-palette-swatch.component.html',
  styleUrls: ['./paint-palette-swatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaintPaletteSwatchComponent implements OnInit {
  @Input()
  colorRecipe: ColorRecipeModel;

  constructor() { }

  ngOnInit() {
  }

  getStyle() {
    if (this.colorRecipe) {
      return {
        'background-color': this.makeColor(this.colorRecipe)
      };
    }

    return '';
  }

  makeColor(colorRecipe: ColorRecipeModel): string {
    const tintColor = colorRecipe.tintColor;

    if (tintColor instanceof ColorFresnelModel) {
      return '#fff';
    } else {
      const [ red, green, blue ] = tintColor as [number, number, number];
      return `rgb(${red * 255}, ${green * 255}, ${blue * 255})`;
    }
  }
}
